/**
 * Created by mqamhieh on 3/28/18.
 */
(function () {

    angular.module('harriApp')
        .controller('JobAlertSubscriptionController', [
            '$scope', '$stateParams', '$state',
            function ($scope, $stateParams, $state) {


                if ($stateParams.token) {
                    HStorageManager.put({
                        storageLevel:  HStorageManager.StorageLevels.SESSION,
                        key: 'emailToken',
                        value: $stateParams.token
                    });

                    SubscriptionAPI.getJobsAlertsSubscription($stateParams.token)
                        .then(function (subscriptionDetails) {
                            $scope.brand_name = subscriptionDetails.base_brand_name;
                            $scope.$digest();
                        });

                    SubscriptionAPI.verifySubscription($stateParams.token)
                        .then(function (data) {
                            // Nothing to do.
                        }, function () {
                            $scope.invalidToken = true;
                            hAlert($filter("translate")("Error"), $filter("translate")("Invalid token."));
                            $scope.$digest();
                        });
                } else {
                    hAlert($filter("translate")("Error"), $filter("translate")("Verification token not found!"));
                    Utils.redirectToWorkspace('homepage');
                }
            }
        ]);

})();